import { initialize } from '../controls/initialize';
import { initialize as initializeLevelOne } from '../level_1/initialize';
import { setCurrentNavLabel as originalSetCurrentNavLabel } from '../set_current_nav_label';
import { loadAndDisplayCartData } from '../level_1/load_and_display_cart_data';
import { ResizeHandler } from '../../resize_handler/resize_handler';
import { resetLevel2 } from '../level_2/reset_level_2';
import { onToggleVisibilityClick } from '../controls/on_toggle_visibility_click';
import { logLinkClicks } from '../google_analytics/log_link_clicks';

export const initializeDefaultNav = $nav => {
    const setCurrentNavLabel = originalSetCurrentNavLabel($nav.find('.navigation-current-nav__label'));
    const $body = $(document.body);
    const $cartCount = $nav.find('.navigation-level-1-cart-count');

    initialize($nav, $body, setCurrentNavLabel);
    initializeLevelOne($nav, setCurrentNavLabel);
    logLinkClicks();

    if ($cartCount.length) {
        loadAndDisplayCartData($cartCount);
    }

    ResizeHandler.subscribe(() => {
        if ($nav.hasClass('navigation--opened')) {
            onToggleVisibilityClick($nav, $body, setCurrentNavLabel, false);
        }
    });
};
